import React from "react";
import { useFullOrderModel } from "../fullOrderModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { fullOrderSDs, fullOrderStatusSDs, fullOrderScmStatusSDs } from "@/types/FmsDs"
import useGlobalModel from '@/model/globalModel';

export function SaleSearchBox() {
    const {
        searchParam,
        initPgCfg,
        resetSearchParam,
        saleLoadData,
        updateSearchParam
    } = useFullOrderModel();
    const { userBranch, } = useGlobalModel()

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "单位名称",
            fieldName: "customerName",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "单据编号",
            fieldName: "code",
        }, {
            type: SearchTypeEnum.Select,
            placeholder: "单据类型",
            fieldName: "tradeTypeCode",
            options: fullOrderSDs
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "制单员",
            fieldName: "createUser",
        }, {
            type: SearchTypeEnum.Select,
            placeholder: "单据状态",
            fieldName: "status",
            options: userBranch === "scm" ? fullOrderScmStatusSDs : fullOrderStatusSDs
        },
    ]

    const searchMoreFields = [
        {
            type: SearchTypeEnum.FullRangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["制单日期起始", "制单日期结束"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
        {
            type: SearchTypeEnum.FullRangePicker,
            fieldName: "",
            rangePickerFieldName: ["settlementStartTime", "settlementEndTime"],
            placeholder: ["结算日期开始", "结算日期结束"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
    ]

    return (
        <YhPageHeader
            title="全量单据列表"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { saleLoadData(initPgCfg, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    );
}